import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

// Render source fields as text; never execute HTML supplied by a connector.
const SampleValue = ({ value, depth = 0 }) => {
  if (value && typeof value === 'object' && depth < 5) {
    return Object.entries(value).slice(0, 40).map(([key, child]) => (
      <Box key={key} sx={{ ml: depth ? 1 : 0, mb: 1 }}>
        <Typography variant="caption" color="text.secondary">{key}</Typography>
        <SampleValue value={child} depth={depth + 1} />
      </Box>
    ));
  }
  const text = typeof value === 'object' ? JSON.stringify(value) : String(value ?? '');
  const isLink = /^https?:\/\/[^\s]+$/i.test(text);
  return <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
    {isLink ? <a href={text} target="_blank" rel="noopener noreferrer">{text}</a> : text}
  </Typography>;
};

export default function CreationSample({ items }) {
  return items.map((item) => {
    let content = item.content;
    try { content = JSON.parse(content); } catch { /* Plain text is a valid sample. */ }
    return <Paper key={item.id} variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="caption" sx={{ overflowWrap: 'anywhere' }}>{item.source} · {item.date}</Typography>
      <SampleValue value={content} />
    </Paper>;
  });
}
